var messages = {
  placeholder: '请选择',
  noOptions: '暂无选项'
};
export default messages;